import type { ReactNode } from 'react';
import { PlatformRequireAuth } from '@jarvis/platform-ui';
import { useAuthStore } from './useAuthStore';

export function RequireAuth({ children }: { children: ReactNode }) {
  return <PlatformRequireAuth useAuthStore={useAuthStore}>{children}</PlatformRequireAuth>;
}
